import React, { useEffect, useRef } from 'react';

const COPY = {
  app: {
    ja: '重要なお知らせ：キャッシュレス決済マップは2026年3月をもってサービス提供を終了しました。現在は、開発した画面・機能をご覧いただけるアーカイブとして公開しています。本サイトの公開は、新規の店舗掲載、契約またはサポートを現在提供していることを示すものではありません。',
    en: 'Important: Cashless Payment Map was discontinued in March 2026. This website remains available as an archive showcasing the screens and functionality that were developed. Its availability does not indicate that new store listings, subscriptions, or support are currently being offered.',
  },
  lp: {
    ja: '重要なお知らせ：キャッシュレス決済マップは2026年3月をもってサービス提供を終了しました。本ページは、提供当時に使用していたランディングページを、開発・事業実績として保存したアーカイブです。掲載されている機能、料金、キャンペーン、試算および効果に関する表現は提供当時の内容であり、現在のサービス提供や効果を保証するものではありません。現在、新規の店舗掲載、契約およびサポートは受け付けていません。',
    en: 'Important: Cashless Payment Map was discontinued in March 2026. This page is an archive of the landing page used while the service was available, retained as a product-development and business showcase. The features, pricing, promotions, estimates, and performance-related statements shown below reflect the content presented at that time and do not indicate current availability or guarantee results. New store listings, subscriptions, and support are no longer being offered.',
  },
};

export function ArchiveNotice({ variant = 'app' }) {
  const noticeRef = useRef(null);
  const copy = COPY[variant] || COPY.app;

  useEffect(() => {
    const notice = noticeRef.current;
    if (!notice) return undefined;

    const updateHeight = () => {
      document.documentElement.style.setProperty('--archive-notice-height', `${notice.offsetHeight}px`);
    };

    updateHeight();
    const observer = typeof ResizeObserver === 'undefined' ? null : new ResizeObserver(updateHeight);
    observer?.observe(notice);
    window.addEventListener('resize', updateHeight);

    return () => {
      observer?.disconnect();
      window.removeEventListener('resize', updateHeight);
      document.documentElement.style.removeProperty('--archive-notice-height');
    };
  }, []);

  return (
    <aside
      ref={noticeRef}
      id="service-ended-notice"
      role="status"
      aria-label="サービス終了とアーカイブ公開に関する重要なお知らせ"
      style={{
        width: '100%',
        boxSizing: 'border-box',
        background: '#7f1d1d',
        color: '#ffffff',
        overflowWrap: 'anywhere',
      }}
    >
      <div
        style={{
          maxWidth: '80rem',
          margin: '0 auto',
          padding: '8px 16px',
          textAlign: 'center',
          fontSize: '14px',
          lineHeight: 1.5,
        }}
      >
        <strong style={{ display: 'block' }}>{copy.ja}</strong>
        <span style={{ display: 'block', marginTop: '4px', fontSize: '12px' }}>{copy.en}</span>
      </div>
    </aside>
  );
}
